<template>
  <section class="section__janczaki">
    <video
      width="auto"
      playsinline
      loop
      muted
      autoplay
      title="Ruchoma grafika - produkty w pudełkach."
    >
      <source
        src="https://ik.imagekit.io/intervi/video/1-janczaki_1920_9OWiuk_6v.mp4"
        type="video/mp4"
      />
      <source
        media="(max-width: 1440px) and (max-resolution: 192dpi)"
        data-srcset="https://ik.imagekit.io/intervi/video/1-janczaki_1440_AMDzNjNAY.mp4"
        type="video/mp4"
      />Your browser does not support the video tag.
    </video>
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";

export default {
  name: "ComponentJanczaki",
  data() {
    return {};
  },
  props: {
    showChild: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.mouseMove();
  },
  methods: {
    mouseMove: function() {
      $(document).mousemove(function(event) {
        $("#hand").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 60,
            ease: Power1.easeOut
          });
        });

        //  $("#car1").each(function(index, element) {
        //   var xPos = event.clientX / $(window).width() - 0.5,
        //     yPos = event.clientY / $(window).height() - 0.5,
        //     box = element;

        //   TweenLite.to(box, 1, {
        //     x: xPos * 20,
        //     ease: Power1.easeOut
        //   });
        // });

        $("#car2").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -40,
            ease: Power1.easeOut
          });
        });
      });
    }
  },
  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentJanczaki.vue